<template>
  <el-drawer custom-class="user_info_modal" v-model="modelMainVisible" @open="openModal" @close="closeModal"
    :destroy-on-close="true" :append-to-body="true" :direction="'btt'">

    <el-button class="button_more" type="transparent" icon="el-icon-more" @click="bottomDropUp = true"></el-button>

    <el-carousel :class="user.files && user.files.length ? 'with_arrow' : ''" trigger="click" :autoplay="false">
      <el-carousel-item>
        <img class="user_image" :src="user.image" v-if="user.image" />
        <el-empty class="user_image" :image="require(`@/assets/img/job-seeker/profile.svg`)" v-else></el-empty>
      </el-carousel-item>
      <el-carousel-item :class="$filters.getFileType(file)" v-for="(file, i) in user.files" :key="file.src">
        <img class="user_image" :src="file.url" alt="" v-if="$filters.getFileType(file) == 'image'" />
        <video-js :options="videoPlayerOptions" :sources="videosSrc[i]" v-if="$filters.getFileType(file) == 'video'" />
      </el-carousel-item>
    </el-carousel>

    <div class="user_image_gradient"></div>
    <div class="user_info_wrapper user_info_wrapper-padding">
      <div class="info_wrapper user_main_info">
        <div class="image_text_comp">
          <div class="text_wrapper">
            <div class="main_text">{{ user.name }}</div>
            <div v-if="user.preferredName" class="main_text">
              <div class="additional_text">Preferred name: {{ user.preferredName }}</div>
            </div>
            <div class="additional_text" v-if="user.settings.ahpraExpDate">
              {{ user.settings.ahpra + ", " + $moment(user.settings.ahpraExpDate).format('DD MMM YYYY')}}
            </div>
            <div class="additional_text">
              <span v-if="userRole == 'pharmacy'">{{ user.address.suburb }}, {{ user.address.state }}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="proof-ins" v-if="user.locumCvs.length > 0">
        <span>Resume</span>
        <div class="resume applicant-actions">
          <div class="resume-row d-flex align-items-center mb-1" v-for="pro in user.locumCvs" :key="pro.url">
            <div class="thumbnail_img el-upload-list--picture-card">
              
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <rect width="32" height="32" fill="url(#pattern0_2575_7976)" />
                <defs>
                  <pattern id="pattern0_2575_7976" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_2575_7976" transform="scale(0.00195312)" />
                  </pattern>
                  <image id="image0_2575_7976" width="512" height="512"
                    xlink:href="data:image/png;base64,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" />
                </defs>
              </svg>

            </div>

            <div class="file-detail">
              <div class="file-name">
                {{ pro.fileName }}
              </div>
              <div class="file-info">
                <span>Size: {{pro.size}} MB</span> |
                <span>Uploaded: {{ pro.createdAt }}</span>
              </div>
            </div>

            <div class="ml-auto cursor-pointer" @click="certPreviewModalOpen(pro)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2V9L14 7" stroke="black" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M12 9L10 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M1.97998 13H6.38998C6.76998 13 7.10998 13.21 7.27998 13.55L8.44998 15.89C8.78998 16.57 9.47998 17 10.24 17H13.77C14.53 17 15.22 16.57 15.56 15.89L16.73 13.55C16.9 13.21 17.25 13 17.62 13H21.98"
                  stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M7 4.12988C3.46 4.64988 2 6.72988 2 10.9999V14.9999C2 19.9999 4 21.9999 9 21.9999H15C20 21.9999 22 19.9999 22 14.9999V10.9999C22 6.72988 20.54 4.64988 17 4.12988"
                  stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="proof-ins" v-if="user.covidCertPro.length > 0">
        <span>Professional Certification</span>
        <div class="applicant-actions professional-certification">
          <div class="resume-row d-flex align-items-center" :class="user.covidCertPro.length > 1 ? 'mb-1' : ''"
            v-for="(certPro) in user.covidCertPro" :key="certPro.url">
            <div class="thumbnail_img el-upload-list--picture-card">
              <div v-if="certPro.extension == 'pdf'">
                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
              </div>
              <div v-else>
                <img class="el-upload-list__item-thumbnail" :src="certPro.url" alt="" />
              </div>
            </div>
            <div v-if="certPro.expiryDate">
              <div class="policy-expire">Policy Expiry</div>
              <div class="expire-date">
                {{ $moment(certPro.expiryDate).format('DD MMM YYYY') }}
              </div>
            </div>
            <div class="ml-auto cursor-pointer" @click="certPreviewModalOpen(certPro)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
                  fill="black" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="proof-ins" v-if="user.insuranceDocument.length > 0">
        <span>Insurance Documents</span>
        <div class="applicant-actions insurance-documents">
          <div class="resume-row d-flex align-items-center" v-for="(insurance) in user.insuranceDocument"
            :key="insurance.url">
            <div class="thumbnail_img el-upload-list--picture-card">
              <div v-if="insurance.extension == 'pdf'">
                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
              </div>
              <div v-else>
                <img class="el-upload-list__item-thumbnail" :src="insurance.url" alt="" />
              </div>
            </div>
            <div v-if="insurance.expiryDate">
              <div class="policy-expire">Policy Expiry</div>
              <div class="expire-date">
                {{ $moment(insurance.expiryDate).format('DD MMM YYYY') }}
              </div>
            </div>
            <div class="ml-auto cursor-pointer" @click="certPreviewModalOpen(insurance)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
                  fill="black" />
              </svg>
            </div>
          </div>
        </div>

      </div>
      <div class="proof-ins" v-if="user.otherInsuranceDocument.length > 0">
        <span>Other Insurance Documents</span>
        <div class="applicant-actions other-insurance-documents">
          <div class="resume-row d-flex align-items-center" v-for="(otherInsurance) in user.otherInsuranceDocument"
            :key="otherInsurance.url">
            <div class="thumbnail_img el-upload-list--picture-card">
              <div v-if="otherInsurance.extension == 'pdf'">
                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
              </div>
              <div v-else>
                <img class="el-upload-list__item-thumbnail" :src="otherInsurance.url" alt="" />
              </div>
            </div>
            <div v-if="otherInsurance.expiryDate">
              <div class="policy-expire">Policy Expiry</div>
              <div class="expire-date">
                {{ $moment(otherInsurance.expiryDate).format('DD MMM YYYY') }}
              </div>
            </div>
            <div class="ml-auto cursor-pointer" @click="certPreviewModalOpen(otherInsurance)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
                  fill="black" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-dialog__footer">
      <el-button class="submit_page" v-if="user.role == 'pharmacy'" type="black" @click="goToMap()">
        <span class="locumate_icons locumate_icon-map"></span><span>Map</span>
      </el-button>
      <el-button class="submit_page w-full" type="blue" @click="goToChat()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
            stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M15.9965 11H16.0054" stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M11.9955 11H12.0045" stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M7.99451 11H8.00349" stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>Start Chat</span>
      </el-button>

      <el-button v-if="params && params.showRemovePrefferedStore" class="submit_page" type="blue"
        @click="showRemovePharmacyConfimation()">
        <span class="locumate_icons locumate_icon-remove_square"></span><span>Remove </span>
      </el-button>


    </div>
  </el-drawer>
  <el-drawer custom-class="bottom_drop_up" v-model="bottomDropUp" :append-to-body="true" :with-header="false"
    :direction="'btt'" :destroy-on-close="true">
    <el-button type="transparent" class="menu_item" @click="sendReport(user)">
      <span class="locumate_icons locumate_icon-flag"></span>
      <span v-if="user.role == 'pharmacy'">Report this pharmacy</span>
      <span v-else>Report {{ user.name }}</span>
    </el-button>
  </el-drawer>
  <cert-applicant-preview-modal :modalName="'certApplicantNextPreviewModal'"
    :options="certApplicantNextPreviewModal"></cert-applicant-preview-modal>
</template>

<script>
import VideoJs from "@/components/VideoJs/VideoJs.vue";
import { ElMessageBox } from "@/components/Vendor/Element";

import {
  ref,
  // reactive,
  onMounted,
  inject,
  computed,
  nextTick,
  
  // nextTick
} from "vue";
import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";

import FileHelpers from "@/helpers/file/file";
import store from "@/store/store";
import { find } from 'lodash'

import CertPreviewModal from "../../CovidCertModal/CertificatePreviewModal.vue";


export default {
  components: {
    VideoJs,
    "cert-applicant-preview-modal": CertPreviewModal
  },
  props: {
    modalName: {
      type: String,
    },
    options: {
      type: Object,
    },
  },
  setup(props) {
    const $moment = inject(["$moment"]);
    const $store = useStore();
    const $router = useRouter();
    const $mitt = inject("$mitt");
    const googleMaps = inject(["googleMaps"]);
    const $modals = inject("$modals");
    const modelMainVisible = ref(false);
    let jobsDistancesCache = store.getters.getJobDistancesData.length
        ? store.getters.getJobDistancesData
        : []; // data from cache
       
    const certApplicantNextPreviewModal = ref({
      name: "certApplicantPrev",
      file: [],
    });
    const certPreviewModalOpen = (file) => {
      if(file.extension == 'pdf'){
        window.open(file.url, '_blank');
      }else{
        console.log("aaa");
      certApplicantNextPreviewModal.value.file = file;
      console.log("🚀 ~ certPreviewModalOpen ~ file:", file)


      $modals.open("certApplicantNextPreviewModal", {
        file: file,
      });
      console.log("end osf posspup");
    }
    };
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const user = computed(() => {
      return props.options.user;
    });

    const params = computed(() => {
      return props.options.params;
    });

    const environment = ref({});

    const distance = ref(null);

    const bottomDropUp = ref(false);

    $mitt.on(props.modalName, (options) => {
      modelMainVisible.value = options.show;
    });

    const isOphioidSelected = computed(() => {
      if (find(user.value.environment.services, ['id', 6])) {
        return true
      }
      return false
    });


    const showRemovePharmacyConfimation = () => {
      (async () => {
        try {
          //make api call
          await ElMessageBox.confirm(
            'Remove this Pharmacy from your Preferred Store List',
            "Remove Store",
            {
              confirmButtonText: "Remove",
              cancelButtonClass: "el-button--grey",
              showClose: false,
            }
          ).then(() => {
            $store.dispatch('REMOVE_PREFERRED_LOCUMS_PHARMACY', {'pharmacyId': user.value.id})

            closeModal();

            $router.push({
              name: "manage_preferred_locum_stores",
            });

          }).catch(() => {
          });
        } catch (error) {
          console.log(error);
        }
      })();
    }


    onMounted(() => {});
    const carouselHeight = ref(null);

    const setCarouselHeight = () => {
      setTimeout(() => {
        nextTick(console.log($(".el-carousel").width()));
        $(".el-carousel").css(
          "--carousel-height",
          `${$(".el-dialog__body").width()}px`
        );
      }, 500);

      // $('.el-carousel').css('--carousel-height', `${$('.el-carousel')[0].innerWidth}px`);
    };

    const videoPlayer = ref([]);
    const videoPlayerOptions = {
      class: "vjs-big-play-centered",
      preload: "auto",
      plugins: {
        seekButtons: {
          forward: 15,
          back: 15,
          forwardIndex: 3,
          backIndex: 2,
        },
      },
      fluid: true,
      bigPlayButton: true,
    };

    let videosSrc = [];

    const openModal = () => {
      window.addEventListener("resize", setCarouselHeight);
      setCarouselHeight();
      const fileHelpers = new FileHelpers();
      if (user.value.role === "pharmacy") {
        if(user.value.files) {
          user.value.files.forEach((file) => {
          if (fileHelpers.getFileType(file) == "video") {
              videosSrc.push([
                {
                  src: file.url,
                  type: "video/" + fileHelpers.getFileExt(file.url),
                },
              ]);
            } else {
              videosSrc.push(null);
            }
          });
        }
      }

      (async () => {
        try {
          if (user.value.role == "pharmacy") {
            const env = await $store.dispatch(
              "GET_USER_ENVIRONMENT",
              user.value
            );
            Object.assign(environment.value, env);
          }

          if (
            user.value.role == "pharmacy" &&
            userData.address &&
            user.value.address.lat
          ) {
            let needToRetrieveDistance = true;

            for (let cacheItem of jobsDistancesCache) { // check if value exists in the cache
              if (
                  user.value.id === cacheItem.id &&
                  cacheItem.cachedAt &&
                  cacheItem.cachedAt > userData.addressChangedAt && cacheItem.cachedAt > user.value.addressChangedAt
              ) {
                needToRetrieveDistance = false;
                distance.value = cacheItem.distance;

                console.log(cacheItem.id);
                console.log("distance item loaded from cache");
                console.log(cacheItem.distance);
                break;
              }
            }

            if (needToRetrieveDistance) {
              const result = await googleMaps.getDistance(userData.address, [
                user.value.address,
              ]);
              distance.value = result[0].elements[0].distance
                  ? result[0].elements[0].distance.text
                  : null;

              if (distance.value) {
                distance.value = distance.value.replace(',', '.')
                if (new RegExp("(.*)(km|км)$", "gm").test(distance.value)) {
                  distance.value = parseFloat(distance.value);
                } else if (new RegExp("(.*)(m|м)$", "gm").test(distance.value)) {
                  distance.value = parseFloat(distance.value) / 1000;
                } else {
                  console.log("not match");
                  console.log(distance.value);
                }

                store.dispatch("setJobDistancesData", {
                  id: user.value.id,
                  distance: distance.value,
                  cachedAt: $moment().tz('UTC').format('YYYY-MM-DD HH:mm:ss')
                });
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      })();
      // }
      // }

      console.log("🚀 ~ openModal ~ user", user.value)
    };
    const closeModal = () => {
      modelMainVisible.value = false;
    };

    const sendReport = (user) => {
      bottomDropUp.value = false;
      $store.dispatch("setReportData", {
        userData: user,
      });
      $router.push({
        name: "report",
        params: {
          userId: user.id,
        },
      });
    };

    
    const goToMap = () => {
      closeModal();

      // ${encodeURI('https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=transit')}
      // https://www.google.com/maps/search/?api=1&query=
      // window.open(`https://www.google.com/maps/place/${user.value.address.lat},${user.value.address.lng}`)

      if (
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPod") != -1 ||
        navigator.platform.indexOf("MacIntel") != -1 ||
        navigator.platform.indexOf("iPad") != -1
      ) {
        const originCord = userData.address.lat + "," + userData.address.lng;

        const destinationCord =
          user.value.address.lat + "," + user.value.address.lng;

        const origin = userData.address ? `saddr=${originCord}&` : "";

        const destination = user.value.address
          ? `daddr=${destinationCord}&`
          : "";

        window.open(
          `http://maps.apple.com/?${origin}${destination}dirflg=d&t=m`
        );
      }

      // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`);
      // window.open(`http://maps.apple.com/?saddr=${userData.address.text}&daddr=${user.value.address.text}&dirflg=d&t=m`);
      else {
        const zoom = `&zoom=16`;
        const origin = userData.address.lat
          ? `&origin=${userData.address.lat},${userData.address.lng}`
          : "";
        const destination = user.value.address.lat
          ? `&destination=${user.value.address.lat},${user.value.address.lng}`
          : "";
        window.open(
          `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`
        );
      }
    };
    const goToChat = () => {
      closeModal();
      const chatId =
        userRole == "pharmacy"
          ? userData.id + "." + user.value.id
          : user.value.id + "." + userData.id;
      // pusher.pusherChatSubscribe(chatId)
      $router.push({
        name: "chat_message",
        params: {
          chatId: chatId,
          // opponentId: user.value.id
        },
      });
    };


    return {
      openModal,
      closeModal,
      // loading,
      modelMainVisible,
      user,
      params,
      userRole,
      distance,
      bottomDropUp,
      environment,
      goToMap,
      goToChat,
      sendReport,
      carouselHeight,
      videoPlayer,
      videoPlayerOptions,
      videosSrc,
      isOphioidSelected,
      showRemovePharmacyConfimation,
      certPreviewModalOpen,
      certApplicantNextPreviewModal,
    };
  },
};
</script>
<style>
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 50px!important;
  height: 50px!important;
  object-fit: cover;
}
.el-upload-list--picture-card .header_logo_text {
  width: 50px;
}
</style>